import request from '@/utils/request';

const allShopSummaryList = data => request({
  url: '/allShopSummary/list',
  method: 'post',
  data,
});
export default allShopSummaryList;
